import { inject, InjectionToken, Injector } from "@angular/core";
import { SidenavItemInterface } from "@app/shared-core/components/side-nav/interfaces/side-nav-items.interface";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@shared/auth/constants/permissions.constant";
import { APP_ROUTE_PATHS } from "@app/app-route-paths";

export const mainSideNavConfig: (injector: Injector) => SidenavItemInterface[] = _ => [
  {
    id: "home",
    items: [],
    icon: "home",
    tooltip: "SIDE_NAV.HOME.TITLE",
    direction: "TOP",
    routerLink: "/",
    routerLinkExact: true,
    // The children decide visibility; listed here so the intent stays readable.
    permissions: [...COMMON_GUARD_OPTIONS.HOME_DASHBOARD.VIEW.permissions, ...COMMON_GUARD_OPTIONS.KPI_COMMISSION.VIEW.permissions],
  },
  {
    id: "news",
    items: [],
    icon: "rss",
    tooltip: "SIDE_NAV.NEWS",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.NEWS,
    permissions: COMMON_GUARD_OPTIONS.ARTICLE.VIEW.permissions,
  },
  {
    id: "stock",
    items: [],
    icon: "fst",
    tooltip: "SIDE_NAV.STOCK",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.STOCK,
    permissions: COMMON_GUARD_OPTIONS.STOCK.VIEW.permissions,
  },
  {
    id: "archive",
    items: [],
    label: "SIDE_NAV.ARCHIVE",
    icon: "archive",
    tooltip: "SIDE_NAV.ARCHIVE",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.ARCHIVE,
    permissions: [...COMMON_GUARD_OPTIONS.ARCHIVE.VIEW.permissions],
  },
  {
    id: "opportunity",
    items: [],
    label: "SIDE_NAV.QUOTATION",
    icon: "quotation",
    tooltip: "SIDE_NAV.QUOTATION",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.QUOTATION,
    permissions: [...COMMON_GUARD_OPTIONS.QUOTATION.VIEW.permissions],
  },
  {
    id: "custom_quote",
    items: [],
    label: "SIDE_NAV.CUSTOM_QUOTE",
    icon: "paint-brush",
    tooltip: "SIDE_NAV.CUSTOM_QUOTE",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.CUSTOM_QUOTATION,
    permissions: COMMON_GUARD_OPTIONS.CUSTOM_QUOTATION.VIEW.permissions,
  },
  {
    id: "ocr_quote",
    label: "SIDE_NAV.OCR_QUOTATION",
    icon: "ocr",
    tooltip: "SIDE_NAV.OCR_QUOTATION",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.OCR_QUOTATION,
    permissions: COMMON_GUARD_OPTIONS.OCR_QUOTATION.VIEW.permissions,
  },
  {
    id: "website_offer",
    label: "SIDE_NAV.WEBSITE_OFFER",
    icon: "wallet",
    tooltip: "SIDE_NAV.WEBSITE_OFFER",
    direction: "TOP",
    routerLink: APP_ROUTE_PATHS.WEBSITE_OFFER,
    permissions: COMMON_GUARD_OPTIONS.WEBSITE_OFFER.VIEW.permissions,
  },
  {
    id: "statistics",
    icon: "activity",
    label: "STATISTICS.TITLE",
    tooltip: "SIDE_NAV.STATISTICS.TITLE",
    direction: "TOP",
    items: [],
  },
  {
    id: "setting",
    items: [],
    label: "SETTINGS.TITLE",
    icon: "settings",
    tooltip: "SIDE_NAV.SETTINGS.TITLE",
    direction: "BTN",
  },
];

export const ADD_MAIN_LINKS = new InjectionToken("ADD_MAIN_LINKS", {
  providedIn: "root",
  factory: () => {
    const injector = inject(Injector);
    const sideNavService = injector.get(SideNavService);
    sideNavService.setMainLinks(mainSideNavConfig(injector));
  },
});
